import {Component, ElementRef, OnInit, Renderer2} from '@angular/core';
import {ScreenService} from "../services/screen.service";

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.scss']
})
export class PagesComponent implements OnInit {
  contentHeight: number;
  constructor(
    private screenService: ScreenService,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.updateHeight();
    this.screenService.resize$.subscribe(() => {
      this.updateHeight();
    });
  }
  updateHeight() {
    this.contentHeight = this.screenService.contentHeight;
    this.renderer.setStyle(this.el.nativeElement.querySelector('.dynamic-height'), 'min-height', `${this.contentHeight}px`, 2);
  }
}
